/**
 * CoLab Lazy Loading Module
 * Ледаче завантаження зображень та відео
 */

export const LazyLoad = {
    // Конфігурація
    config: {
        rootMargin: '50px 0px',  // Завантажувати за 50px до появи
        threshold: 0.01
    },

    observer: null,
    videoObserver: null,

    init: function() {
        // Перевіряємо підтримку IntersectionObserver
        if (!('IntersectionObserver' in window)) {
            this.loadAllImmediately();
            return;
        }

        this.initImageObserver();
        this.initVideoObserver();
        this.observeElements();

        console.log('[CoLab.LazyLoad] Initialized');
    },

    // ============================================
    // Image Lazy Loading
    // ============================================
    initImageObserver: function() {
        var self = this;

        this.observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    self.loadImage(entry.target);
                    self.observer.unobserve(entry.target);
                }
            });
        }, this.config);
    },

    loadImage: function(img) {
        // data-src → src
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }

        // data-srcset → srcset
        if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
        }

        // Видаляємо placeholder клас
        img.classList.remove('lazy');
        img.classList.add('lazy-loaded');

        // Callback після завантаження
        img.addEventListener('load', function() {
            img.classList.add('is-loaded');
        });
    },

    // ============================================
    // Video Lazy Loading
    // ============================================
    initVideoObserver: function() {
        var self = this;

        this.videoObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    self.loadVideo(entry.target);
                    self.videoObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '100px 0px',
            threshold: 0.01
        });
    },

    loadVideo: function(video) {
        // data-src → src
        if (video.dataset.src) {
            video.src = video.dataset.src;
        }

        // Завантажуємо source елементи
        var sources = video.querySelectorAll('source[data-src]');
        sources.forEach(function(source) {
            source.src = source.dataset.src;
        });

        // Починаємо завантаження
        video.load();
        video.classList.add('lazy-loaded');

        console.log('[CoLab.LazyLoad] Video loaded');
    },

    // ============================================
    // Observe Elements
    // ============================================
    observeElements: function() {
        var self = this;

        // Зображення з класом .lazy або data-lazy
        var lazyImages = document.querySelectorAll('img.lazy, img[data-src]');
        lazyImages.forEach(function(img) {
            self.observer.observe(img);
        });

        // Відео з data-src
        var lazyVideos = document.querySelectorAll('video[data-src], video.lazy');
        lazyVideos.forEach(function(video) {
            self.videoObserver.observe(video);
        });

        console.log('[CoLab.LazyLoad] Observing', lazyImages.length, 'images,', lazyVideos.length, 'videos');
    },

    // ============================================
    // Fallback для старих браузерів
    // ============================================
    loadAllImmediately: function() {
        var lazyImages = document.querySelectorAll('img[data-src]');
        lazyImages.forEach(function(img) {
            if (img.dataset.src) img.src = img.dataset.src;
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        });

        var lazyVideos = document.querySelectorAll('video[data-src]');
        lazyVideos.forEach(function(video) {
            if (video.dataset.src) video.src = video.dataset.src;
            video.load();
        });
    },

    // ============================================
    // Public API
    // ============================================

    // Примусово завантажити елемент
    load: function(element) {
        if (element.tagName === 'IMG') {
            this.loadImage(element);
        } else if (element.tagName === 'VIDEO') {
            this.loadVideo(element);
        }
    },

    // Додати новий елемент до спостереження
    observe: function(element) {
        if (element.tagName === 'IMG') {
            this.observer.observe(element);
        } else if (element.tagName === 'VIDEO') {
            this.videoObserver.observe(element);
        }
    },

    // Оновити (для динамічно доданого контенту)
    refresh: function() {
        this.observeElements();
    }
};
